import { useState } from 'react';
import { Input } from 'antd';
import type { InputRef } from 'antd';

export interface MoneyInputProps {
  value: string | null;
  onChange: (value: string | null) => void;
  autoFocus?: boolean;
  disabled?: boolean;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  inputRef?: React.Ref<InputRef>;
  navRow?: number;
  navCol?: number;
}

const DRAFT_REGEX = /^\d{0,12}([.,]\d{0,2})?$/;

/** Денежная сумма, до 2 знаков после точки (§1). Запятая трактуется как точка. Коммит на blur/Enter. */
export function MoneyInput({ value, onChange, autoFocus, disabled, onKeyDown, inputRef, navRow, navCol }: MoneyInputProps) {
  const [draft, setDraft] = useState(value ?? '');
  const [prevValue, setPrevValue] = useState(value);
  if (value !== prevValue) {
    setPrevValue(value);
    setDraft(value ?? '');
  }

  const commit = () => {
    const normalized = draft.replace(',', '.');
    const parsed = normalized === '' || normalized === '.' ? null : normalized;
    const formatted = parsed === null ? null : Number(parsed).toFixed(2);
    setDraft(formatted ?? '');
    if (formatted !== value) onChange(formatted);
  };

  return (
    <Input
      ref={inputRef}
      value={draft}
      inputMode="decimal"
      autoFocus={autoFocus}
      disabled={disabled}
      className={navRow !== undefined ? 'nav-cell' : undefined}
      data-nav-row={navRow}
      data-nav-col={navCol}
      style={{ textAlign: 'right', width: '100%' }}
      onChange={(e) => {
        const next = e.target.value;
        if (DRAFT_REGEX.test(next)) setDraft(next);
      }}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') commit();
        onKeyDown?.(e);
      }}
    />
  );
}
